import {
    EXT_IFRAME_ALLOW,
    EXT_REC_IFRAME_SRC,
    getRecIframe,
    REC_IFRAME_ID,
} from '../parentConfig'
import { awaitDOMElement } from '../../services/utils'
import { recIframeMessageReceiver } from './messageReceiver'
import { locationObserver } from './locationObserver'

export const injectRecIframe = () =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise<HTMLElement | null>(async resolve => {
        const existingRecIframe = getRecIframe()

        if (existingRecIframe) {
            existingRecIframe.remove()
        }

        const recIframe: any = document.createElement('iframe')
        recIframe.id = REC_IFRAME_ID
        recIframe.src = EXT_REC_IFRAME_SRC
        recIframe.allow = EXT_IFRAME_ALLOW
        recIframe.style.display = 'none'
        recIframe.style.position = 'fixed'
        recIframe.style.top = '0'
        recIframe.style.left = '0'
        recIframe.style.width = '100vw'
        recIframe.style.height = '100vh'
        recIframe.style.border = 'none'
        recIframe.style.zIndex = '9999999'

        recIframeMessageReceiver(recIframe)
        // Detects URL changes and sends new URL to React
        // Auto tags are disabled for recording iframe to reduce the amount of calls to firebase (apps collection)
        locationObserver(recIframe, true)

        const html = await awaitDOMElement('html')

        if (html) {
            html.appendChild(recIframe)
            resolve(recIframe)
        } else {
            resolve(null)
        }
    })
